import React, {Component, useState} from "react";
import PlayerProfileCard from "./PlayerProfileCard";
import PlayerDetails from "./PlayerDetails/PlayerDetails";
import {gql, useQuery} from "@apollo/client";

import Tools from "../../../Tools";
import dustinWilliamsonAvatar from "../../../assets/img/demo/dustin-williamson-avatar.png";
import darrellMckinneyAvatar from "../../../assets/img/demo/darrell-mckinney-avatar.png";
import team1Logo from "../../../assets/img/demo/team-logo-1.png";
import team2Logo from "../../../assets/img/demo/team-logo-2.png";
import Loading from "../feedback/Loading";
import NoError from "../feedback/NoError";

class PlayerSummary extends Component {

    render = () => {
        return this.renderContent();
    };

    renderContent = () => {
        return (
            <div className="player-summary">
                {this.renderProfile()}
                {this.renderDetails()}
                {this.renderPadding()}
            </div>
        )
    };


    renderProfile = () => {
        const {data, page, onBookmarkClick} = this.props;
        const {avatar, bookmarked, profile, id} = data;
        const {score, value, wage} = profile;


        console.log(avatar);

        return (
            <PlayerProfileCard data={data} id={id} avatar={avatar} score={score} value={value} wage={wage} bookmarked={bookmarked} page={page} onBookmarkClick={onBookmarkClick}/>
        );
    };

    renderDetails = () => {
        const {data, page} = this.props;
        const {careerStats, performance, transfers, positions} = data;

        return (
            <PlayerDetails
                page={page}
                careerStats={careerStats}
                positions={positions}
                performance={performance}
                transfers={transfers}/>
        );
    };

    renderPadding = () => {
        return (
            <div className="padding-top"/>
        );
    };
}

const PlayerSummaryDataWrapper = props => {
    const query = gql`
        query getPlayerDetails ($playerId: String!){
            player: player(id: $playerId){
                ...playerFieles
            }
        }

        fragment playerFieles on PlayerModel{
            avatar
            name
            wage
            overallScore
            careerStats{
                season{
                    name
                    id
                }
                goalsScored
                shootAccuracy
                passingAccuracy
                tackleSuccessRate
            }

            positions{
                position
                map{
                    location
                    color
                }
            }

            performance{
                name
                attributes{
                    name
                    value
                }
            }

            transferValue
            contractExpireAt
            transferredFrom{
                name
                logo
            }
            team{
                name
                logo
            }
        }
    `;

    const formatProfile = player => ({
        score: player.overallScore,
        value: Tools.formatterNumber(player.overallScore),
        wage: Tools.formatterNumber(player.wage),
        avatar: player.avatar,
    });

    const formatCareerStats = player => {
        return player.careerStats;
    };

    const formatPerformance = player => (
        player.performance
    );

    const formatTransfers = player => {
        const {team, transferredFrom, contractExpireAt, transferValue} = player;

        const currentTeamDescription = `Contract Expires on ${Tools.convertDateToYearMonth(new Date(contractExpireAt))}`;
        const transferredFromTeamDescription = `Transfered for $${Tools.formatterNumber(transferValue)}`;

        return {
            currentTeam: {
                name: team.name,
                logo: team.logo,
                description: currentTeamDescription,
            },
            transferredFrom: {
                name: transferredFrom.name,
                logo: transferredFrom.logo,
                description: transferredFromTeamDescription,
            },
        };
    };

    const formatPositions = player => {
        return player.positions;
    };

    const formatter = (player) => ({
        id: props.id,
        avatar: player.avatar?.length ? player.avatar : dustinWilliamsonAvatar,
        value: Tools.formatterNumber(player.overallScore),

        profile: formatProfile(player),
        careerStats: formatCareerStats(player),
        performance: formatPerformance(player),
        transfers: formatTransfers(player),
        positions: formatPositions(player),
    });


    const {loading, error, data} = useQuery(query, {
        variables: {
            playerId: props.id,
        }
    });

    const {page, onExpanding} = props;
    onExpanding(!!loading, !!error, !!data);

    if (loading) {
        return (
            <div className="player-summary--wrapper loading"/>
        );
    } else if (error) {
        return (
            <div className="player-summary--wrapper error done">
                <PlayerSummary.Error/>
            </div>
        );
    } else {
        const {player} = data;
        return (
            <div className="player-summary--wrapper done">
                <PlayerSummary data={formatter(player)} page={page}/>
            </div>
        );
    }
};

PlayerSummary.Loading = props =>
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <Loading text={"Loading..."} details={"Please wait. While we fetch the data"}/>
    </div>;

PlayerSummary.Error = props =>
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <NoError text={"Sorry, Something is broken"} details={"We unable to retrieve data at this moment."}/>
    </div>;

export default PlayerSummaryDataWrapper;
